module.exports = __webpack_public_path__ + "img/cpp.5be9bde4.svg";